export const bulkPricingResponseErrorColumns = [
  'pricing_job_id',
  'job_id',
  'run_id',
  'account_id',
  'account_number',
  'payer_position',
  'error_code',
  'error_description',
  'error_message',
  'error_type',
  'solution',
  'solution_id',
  'rule_execution_id',
  'day',
  '_cdc_hash',
  '_cdc_seq'
];